import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CodeSystemService } from 'app/mdm/terminology/codesystem/services/codesystem.service';
import { DateRange } from '@heda/core-util';
import { CodeSystem, CodeSystemConcept } from 'app/mdm/terminology-lib/services/codesystem';

@Component({
  templateUrl: './codesystem-concept-edit.component.html',
})
export class CodeSystemConceptEditComponent implements OnInit {
  public isEdit = false;
  public codeSystem: CodeSystem;
  public concept: CodeSystemConcept;
  public hidden: { [key: string]: boolean } = {};

  constructor(
    private codeSystemService: CodeSystemService,
    private route: ActivatedRoute,
    private location: Location
  ) {}

  public ngOnInit(): void {
    const codeSystemId = this.route.snapshot.paramMap.get('csid');
    const conceptId = Number(this.route.snapshot.paramMap.get('id'));
    if (!codeSystemId) {
      return;
    }
    this.codeSystemService.getCodeSystem(codeSystemId, true).subscribe((r) => {
      this.codeSystem = r;
      if (this.codeSystem.notes && this.codeSystem.notes['hidden']) {
        this.codeSystem.notes['hidden'].forEach((h) => (this.hidden[h] = true));
      }
      if (conceptId) {
        this.isEdit = true;
        this.concept = this.findConcept(conceptId, this.codeSystem.concepts);
      } else {
        this.concept = new CodeSystemConcept();
        this.concept.attributes = {};
        this.concept.valid = new DateRange();
        if (this.codeSystem.attributes) {
          this.codeSystem.attributes
            .filter((a) => !!a.defaultValue)
            .forEach((a) => {
              this.concept.attributes[a.id] =
                a.defaultValue instanceof Object ? Object.assign({}, a.defaultValue) : a.defaultValue;
            });
        }
      }
    });
  }

  private findConcept(codeSystemId: number, concepts: Array<CodeSystemConcept>): CodeSystemConcept {
    let conc = concepts.find((concept) => concept.id === codeSystemId);
    if (conc) {
      return conc;
    }
    for (const concept of concepts.filter((c) => c.children)) {
      conc = this.findConcept(codeSystemId, concept.children);
      if (conc) {
        conc.parent = concept.code;
        return conc;
      }
    }
  }

  public save(): void {
    delete this.concept.children;
    const csAttrKeys = this.codeSystem.attributes.map((a) => a.id);
    Object.keys(this.concept.attributes)
      .filter((a) => !csAttrKeys.includes(a))
      .forEach((a) => delete this.concept.attributes[a]);

    // Tidy up attributes of type string[] to be comma separated strings
    Object.keys(this.concept.attributes).forEach((key) => {
      if (Array.isArray(this.concept.attributes[key])) {
        this.concept.attributes[key] = this.concept.attributes[key].join(',');
      }
    });

    if (this.isEdit) {
      this.codeSystemService.updateConcept(this.codeSystem.id, this.concept).subscribe((r) => this.goBack());
    } else {
      this.codeSystemService.createConcept(this.codeSystem.id, this.concept).subscribe((r) => this.goBack());
    }
  }

  public goBack(): void {
    this.location.back();
  }

}
